{
  "private": false,
  "publishConfig": {
    "access": "public"
  },
  "name": "@todesktop/cli",
  "version": "1.24.0",
  "license": "MIT",
  "author": "Dave Jeffery <dave@todesktop.com> (http://www.todesktop.com/)",
  "homepage": "https://todesktop.com/cli",
  "bugs": {
    "email": "dave@todesktop.com"
  },
  "bin": {
    "todesktop": "./dist/cli.js"
  },
  "types": "./dist/types.d.ts",
  "engines": {
    "node": ">=16"
  },
  "files": [
    "scripts/postinstall.js",
    "schemas",
    "dist",
    ".env",
    "README.md"
  ],
  "dependencies": {
    "@segment/analytics-node": "^2.3.0",
    "@sentry/node": "^10.29.0",
    "ajv": "^8.17.1",
    "ajv-formats": "^3.0.1",
    "archiver": "^7.0.1",
    "axios": "^1.13.2",
    "better-ajv-errors": "^2.0.3",
    "bunyan": "^1.8.15",
    "chalk": "^4.1.2",
    "commander": "^14.0.2",
    "conf": "^10.2.0",
    "date-fns": "^4.1.0",
    "del": "^6.1.1",
    "dotenv": "^17.2.3",
    "du": "^1.0.0",
    "email-regex": "^4.0.0",
    "fast-glob": "^3.3.3",
    "final-form": "^5.0.0",
    "find-up": "^5.0.0",
    "firebase": "^12.6.0",
    "git-rev-sync": "^3.0.2",
    "ink": "^3.2.0",
    "ink-gradient": "^2.0.0",
    "ink-link": "^2.0.1",
    "ink-select-input": "^4.2.2",
    "ink-text-input": "^4.0.3",
    "is-ci": "^4.1.0",
    "is-installed-globally": "^0.4.0",
    "js-yaml": "^4.1.1",
    "latest-version": "^5.1.0",
    "lodash.merge": "^4.6.2",
    "lodash.throttle": "^4.1.1",
    "parse-author": "^2.0.0",
    "pkg-up": "^3.1.0",
    "pretty-bytes": "^5.6.0",
    "prop-types": "^15.8.1",
    "react": "^17.0.2",
    "react-final-form": "^7.0.0",
    "semver": "^7.7.3",
    "source-map-support": "^0.5.21",
    "stream-to-array": "^2.3.0",
    "superagent": "^10.2.3",
    "uuid": "^11.1.0",
    "ws": "^8.18.3",
    "xdg-basedir": "^4.0.0"
  },
  "packageExtensions": {
    "ink-progress-bar@*": {
      "dependencies": {
        "react": "*",
        "ink": "*"
      }
    }
  }
}
